function useTranslation() {
  function t(value: string) {
    if (!value) return '';
    return value
      .split('_')
      .map((word) => {
        const words = ['and', 'or', 'of', 'the', 'in', 'on', 'at', 'to', 'a', 'an'];
        if (words.includes(word.toLowerCase())) return word.toLowerCase();
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' ');
  }

  return { t };
}

export default useTranslation;
